"use strict";

lazySizes.init();